import styled from 'styled-components';

export default styled.div`
  h3 {
    font-size: .9rem;
    font-weight: bold;
    line-height: 1rem;
    margin: 0;
    width: auto;
  }
  .panel {
    border: solid 1px #EEE;
  }
  .panel-button {
    background-color: lightyellow;
    padding: 10px;
  }
  .panel-button:after {
    font-size: 1rem;
    right: 10px;
    top: 7px;
  }
  .panel-collapse {
    background-color: transparent;
    border-top: solid 1px #EEE;
  }
  .panel-content {
    margin: 0;
  }
  .dpp-search {
    padding: 20px 20px 10px 20px;
    h3 {
      font-size: .9rem;
      line-height: 1rem;
      font-weight: 700;
    }
    label {
      display: none;
    }

    .form-control {
      font-size: .85rem;
      line-height: 1rem;
    }
    input {
      padding-right:70px;
    }

    button {
      font-size: 20px;
      min-width: 50px;
      padding: 10px;

      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      position: absolute;
      bottom:0;
      right:0;
    }

    h3.label, .form-group {
      font-size: .9rem;
      line-height: 1rem;
      margin-bottom: 5px;
    }

    .default-msg {
      .initial-msg {
        color: #CCC;
        margin-top:45px;
        text-align: center;
      }

      span a {
        display: none;
      }

      span.unavailable{
        color:#09757A;
      }
    }
  }
  .default-msg {
    h4 {
      font-size: .9rem;
      line-height: 1rem;
      padding-bottom: 10px;
      border-bottom: solid 1px #EEE;
    }
  }
  .dpp-results {
    .domain-result {
      border: solid 1px #eee;
      display: ${props => props.spinsDisplay};
      margin: 0 20px 10px;
    }
    .domain-result.exact-match {
      margin-bottom: 20px;
      display: block;
    }

    .spins-header {
      font-size: 1rem;
      font-weight: bold;
      line-height: 1.5rem;
      padding: 0 20px;
      display: ${props => props.spinsDisplay};
    }

    .domain-result {
      padding: 10px;
      vertical-align: middle;

      .domain-name {
        display: inline-block;
        font-size: .85rem;
        width: 100%;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
        width: 65%;
        .premium-tooltip {
          font-size: .8em;
        }
        .uxicon {
          vertical-align: inherit;
        }
      }
      .buy-btn-wrap {
        display: flex;
        width: 100%;
        font-size: .85rem;
        div {
          display: flex;
          height: 1.5rem;
          width: 100%;
        }

        .unavailable {
          color: #999;
        }

        h6 {
          font-size: .85rem;
          line-height: 24px;
        }
      }
      .price-block {
        display: inline!important;
        width: auto!important;
        small {
          strong {
            font-weight: normal;
          }
        }
      }
      .dpp-price {
        color: #09757A;
        margin-right: 5px;
      }
      .btn-sm {
        margin: -.8rem 0 1rem auto;
        color: #111!important;
        background: #fff!important;
        border-color: #111!important;
        border-width: 2px;
        padding-top: 2px;
        max-width: 100px;
      }
      .btn-sm:hover {
        color: #09757A!important;
      }
    }
  }
  .disclaimer {
    padding: 0 20px 20px;
    font-size: .85rem;
    line-height: 1rem;

    .renewal-msg {
      color: #777;
      margin-bottom: 10px;
    }
  }
`;
